export default {
  meta: {},
  pages: [],
  blogs: []
};



// WEBPACK FOOTER //
// ./client/RLX/State/Content/ContentInitialState.js